import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.set-prototype-of";
import _throttle from "lodash/throttle";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
var zIndexSizes = ['sm', 'md', 'lg'];

var MediaQuerySize =
/*#__PURE__*/
function (_Component) {
  _inherits(MediaQuerySize, _Component);

  function MediaQuerySize(props) {
    var _this;

    _classCallCheck(this, MediaQuerySize);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MediaQuerySize).call(this, props));
    _this.state = {
      size: ''
    };
    return _this;
  }

  _createClass(MediaQuerySize, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.size !== this.state.size) {
        this.props.onSizeChange(this.state.size);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "getSize",
    value: function getSize() {
      return this.state.size;
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var _this2 = this;

      _throttle(function () {
        var node = _this2.mediaQuerySize; // prevents errors on jsdom tests

        if (!node) {
          return;
        }

        var zIndex = +window.getComputedStyle(node).getPropertyValue('z-index');
        var size = zIndexSizes[zIndex];

        _this2.setState({
          size: size
        });
      }, 10);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React.createElement("div", {
        ref: function ref(c) {
          _this3.mediaQuerySize = c;
        },
        className: "media-query-size"
      });
    }
  }]);

  return MediaQuerySize;
}(Component);

MediaQuerySize.displayName = 'MediaQuerySize';
MediaQuerySize.propTypes = {
  onSizeChange: PropTypes.func
};
MediaQuerySize.defaultProps = {
  onSizeChange: function onSizeChange() {}
};
export default MediaQuerySize;